module.exports = __webpack_public_path__ + "static/bg05-48c470b9e9ee38240e9d0eea327383f5.jpg";